import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { setSubHeading } from "../../store/reducers/CommonReducer"
import { getImage, getTranslated } from "../../utils/CommonUtils"
import { LINKS_LIST } from "../../utils/Constants"
import { Card, Flex } from "antd"
import Meta from "antd/es/card/Meta"
import parse from 'html-react-parser';
import IconLink from "../../assets/images/themed-icons/dark-icon-link.svg";
import { sendGTMEvent } from "../../utils/GTMUtils"

const Links = () => {

    const dispatch = useDispatch()
    const dict = useSelector(state => state.common.dict)

    useEffect(() => {
        dispatch(setSubHeading(getTranslated(dict, "APP_LINKS")))
    }, [dict])


    const handleLinkSelection = (linkName) => {
        // Send GTM event on link click along with link name
        sendGTMEvent({
            event: "umc_links",
            selected_item: linkName
        })
    }


    return <div className="links-list">
        <Flex wrap={true} gap="2em" justify="space-between">
            {LINKS_LIST.map( (link, index) =>
                <Card className="link-card" key={link.key || index}
                    cover={
                        <>
                            <a href={link.link} target="_blank" onClick={() => handleLinkSelection(link.key)} rel="noopener noreferrer" className="link-card-wrapper">
                                <div className="link-card-title" >
                                    <img alt="Link icon" className="link-card-title-icon" src={IconLink} />
                                    <div className="ant-card-meta-title">{parse(getTranslated(dict, link.label))}</div>
                                </div>
                            </a>
                            <img alt={link.image} src={getImage(link.image)} />
                        </>
                    }
                >
                    <Meta description={parse(getTranslated(dict, link.description))} />
                </Card>
            )}
        </Flex>
    </div>
}

export default Links